export default "__VITE_ASSET__KEA4a8OL__"